import React from 'react';


 export function Main(){
    return (
        <main className='landing'>
            <div className="container">
              <div className='img-landing'>
                <img src='images/illustration-intro.png' alt='landin-img'/>
                <h1> All your files in one secure location, accessible anywhere.</h1>
              </div>
              <div className='description'>
                <p className='paragraph'>
                Fylo stores all your most important files in one secure location. Access them wherever 
    you need, share and collaborate with friends family, and co-workers.
                </p>
                <button> Get started</button>
              </div>
            </div>
            <img src='images/bg-curvy-desktop.svg' alt='img-curv'/>
        </main>
    );
}
export default Main;